import React from 'react'
import { withStyles, Typography } from '@material-ui/core'
import styles from './styles'
import useCardData from 'src/hooks/useCardData'
import { LastPageView } from './components'
const EndingPage = props => {
  const { classes, sections, setSections } = props
  return (
    <div
      style={{
        width: '100%',
      }}
      id="page-view-container"
    >
      <div className={classes.container}>
        <LastPageView sections={sections} setSections={setSections} />
      </div>
    </div>
  )
}

export default withStyles(styles)(EndingPage)
